import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AskGeoService {
    constructor(private http: HttpClient) {}

    getSearchResults(searchKey: string): Observable<any> {
        return this.http.get<any>(`${environment.baseUrl}dashboard/askgeo?searchKey=${searchKey}`);
    }
}